import type { Delta, Op } from 'quill/core';
import React from 'react';
import docky from '../../images/docky.svg';
import PostModalView from './PostModalView';
import * as styles from './ProductUpdateModal.module.scss';

interface ProductUpdateModalProps {
  banner: string;
  content: Delta | Op[];
  publishedDate: string;
  newTabTo?: string;
  close: () => void;
}

const ProductUpdateModal = ({
  banner,
  content,
  publishedDate,
  newTabTo = 'https://slab.com/blog/',
  close,
}: ProductUpdateModalProps) => (
  <PostModalView
    post={{
      id: 'product-update',
      banner: {
        original: banner,
      },
      content: {
        id: 'product-update-content',
        delta: content,
      },
      title: 'Product Update',
    }}
    headerBar={
      <div className={styles.headerBar}>
        <img src={docky} width={20} alt="Slab" />
        <div>New in Slab</div>
        <div className={styles.meta}>Published</div>
        <div>{publishedDate}</div>
      </div>
    }
    entityAssetToken={{ __typename: 'EntityAssetToken', token: '' }}
    newTabTo={newTabTo}
    onClose={close}
  />
);

export default ProductUpdateModal;
